import { useContext, useEffect, useMemo, useRef, useState } from "react"
import _ from "underscore";
import { useCommon } from "../../Common/useCommon";
import { decryptData } from "../../../utils/encrypt";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { convertTo24HourFormat, dateConvert } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";
import { DateTime } from "luxon";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";
import { callautopopulate } from "../../../services/callautopop";
import { useImportData } from "../ImportData/useImportData";
import { calculateWordsFromString } from "../../../utils/Helper";

export const useLogwork = ({ closePopup, onSave, addLogData, editFlag, handleDateSelected, isMyBucket, clickedRowTaskId }) => {

    const tagRef = useRef(null);
    const [userCode] = useState(decryptData(sessionStorage.getItem("user_code")));
    const { selectedEmployee } = useEmployeFilter();
    const { projectOpts, getUserProjects, getValuePermission } = useCommon();
    const { showSuccess, showError, showInfo } = useContext(ToastContext)
    const [dateSelected, setDateSelected] = useState(null);
    const [timeSelected, setTimeSelected] = useState({});
    const [timeDropdown, setTimeDropdown] = useState([]);
    const [logsValue, setLogsValue] = useState("");
    const [selectFromTask, setSelectFromTask] = useState(false);
    const [apiEditData, setApiEditData] = useState({});
    const [editLogData, setEditLogData] = useState({});
    const [options, setOptions] = useState({
        tasks: [],
        projects: [],
        clients: [],
        all_clients: [],
        project_module: [],
        types: [],
        is_disabled: false
    })
    const [optionSelected, setOptionSelected] = useState({
        tasks: null,
        projects: {},
        client: {},
        project_module: {},
        types: {}
    })
    const [progressValue, setProgressValue] = useState(0);
    const [logData, setLogData] = useState({
        estimate: 0,
        remaining: 0,
        remainingApi: 0,
        logged: 0,
        entered_hours: 0,
        entered_hours_string: ""
    })
    const [error, setError] = useState("");
    const [loaderButton, setLoaderButton] = useState(false);
    const [navigateDate, setNavigateDate] = useState(false);
    const [confirmationPopup, setConfirmationPopup] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [logDetails, setLogDetails] = useState([]);
    const [importDataPopup, setImportDataPopup] = useState(false);
    const [spin, setSpin] = useState(false);
    const [showStatusPopup, setShowStatusPopup] = useState({ show: false, setLoader: false });
    const { handleUpsertImportData } = useImportData()

    useEffect(() => {
        getUserIssues();
        getUserProjects();
        sessionStorage.removeItem("client");
        callautopopulate("client", "issue_type", "request_approver_leads").then(res => {
            setOptions((prev) => ({ ...prev, all_clients: _.sortBy(res?.client, 'client_name'), issueType: _.sortBy(res?.issue_type, 'issue_type_name'), approverList: res?.request_approver_leads }))
        })
        if (!getValuePermission("add_log_date_navigate_btn")) {
            setNavigateDate(true);
        } else {
            setNavigateDate(false);
        }
    }, [])

    useEffect(() => {
        if (_.isEmpty(optionSelected.tasks)) {
            setSelectFromTask(false);
        }
    }, [optionSelected.tasks])

    // set project options from common API call
    useEffect(() => {
        setOptions((prev) => ({ ...prev, projects: projectOpts }));
    }, [projectOpts])

    // update progress bar when log hour entered
    useEffect(() => {
        if (!_.isEmpty(logData)) {
            calculatePercentage(logData?.logged * 60);
        }
    }, [logData.logged]);

    useEffect(() => {
        if (!_.isEmpty(editLogData) && editLogData !== undefined && !_.isEmpty(options)) {
            getEditData();
        }
    }, [editLogData, editFlag])

    useEffect(() => {
        if (!_.isEmpty(addLogData) && addLogData !== undefined && !_.isEmpty(options.projects)) {
            handleTaskSelect(addLogData);
        }
    }, [addLogData, options.projects])

    useEffect(() => {
        if (!_.isEmpty(apiEditData)) {
            handleEditValues();
        }
    }, [apiEditData])

    useEffect(() => {
        if (!_.isEmpty(optionSelected.projects) && !options.is_disabled) {
            handleProjectIssueType();
            getProjectModule();
        } else if (_.isEmpty(optionSelected.projects)) {
            setOptionSelected((prev) => ({ ...prev, project_module: {} }));
        } else if (!options.is_disabled) {
            setOptions((prev) => ({ ...prev, types: [] }));
        }
        handleClientFilter();

    }, [optionSelected.projects])

    useEffect(() => {
        if (options?.isSet) {
            if (_.isEmpty(logDetails) && _.isEmpty(editLogData)) {
                const data = generateTimeSlots()
                setTimeDropdown(data);
                if (!navigateDate && _.isEmpty(timeSelected)) { setTimeSelected(data?.[0]) }
            } else if (!_.isEmpty(logDetails)) {
                if (_.isEmpty(editLogData) && !timeSelected) {
                    setTimeSelected({})
                }
                formatTimeDropdown(logDetails);
            }
            if (timeSelected?.value && logData?.entered_hours) {
                const newLabel = getTimeSlotLabel(timeSelected.value, logData?.entered_hours);
                setTimeSelected(prev => prev ? { ...prev, label: newLabel } : prev);
            }
        }
    }, [logDetails, logData?.entered_hours, options?.isSet])


    const getTimeSlotLabel = (startValue, durationMinutes) => {
        const [startHour, startMinute] = startValue.split(':').map(Number);
        const totalStartMinutes = startHour * 60 + startMinute;
        const totalEndMinutes = totalStartMinutes + durationMinutes;
        const endHour = Math.floor(totalEndMinutes / 60) % 24;
        const endMinute = totalEndMinutes % 60;
        return `${formatTime(startHour, startMinute)}-${formatTime(endHour, endMinute)}`;
    };


    const getProjectModule = async (id) => {
        const payload = {
            "project_ids": id ? _.pluck(id, "project_id").toString() : optionSelected?.projects?.project_id?.toString() || 0
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTMODULE'), payload);

            if (id) {
                setOptions((prev) => ({ ...prev, filter_project_module: _.sortBy(res.body.data.project_module, 'option_value') }));
            } else {
                setOptions((prev) => ({ ...prev, project_module: _.sortBy(res.body.data.project_module, 'option_value') }));
                if (_.isEmpty(_.findWhere(res.body.data.project_module, { option_id: optionSelected?.project_module?.option_id }))) {
                    setOptionSelected((prev) => ({ ...prev, project_module: {} }));
                }
                if (!_.isEmpty(apiEditData)) {
                    const project_module = _.findWhere(res.body.data.project_module, { option_id: apiEditData?.project_module_id }) || {};
                    setOptionSelected((prev) => ({ ...prev, project_module }));
                }
            }
        }
        catch (error) {
            console.error(error, "error");
        }

    }

    const handleClientFilter = (fromEdit) => {
        let filteredClients = [];
        if (fromEdit) {
            filteredClients = _.filter(options?.all_clients, (item) => _.findWhere(options?.projects, { project_id: apiEditData?.project_id })?.client_ids?.includes(item?.client_id));
        } else {
            filteredClients = _.filter(options?.all_clients, (item) => optionSelected?.projects?.client_ids?.includes(item?.client_id));
        }
        if (!fromEdit) {
            if (filteredClients?.length === 1) {
                setOptionSelected((prev) => ({ ...prev, client: filteredClients?.[0] }))
            } else if (_.isEmpty(filteredClients)) {
                setOptionSelected((prev) => ({ ...prev, client: {} }));
            }
        }
        setOptions((prev) => ({ ...prev, clients: filteredClients }));
    }

    // when time selected or entered from editable dropdown
    const handleTimeSelected = (newValue) => {
        if (typeof (newValue) === "object") {
            const time = (newValue?.value.toLowerCase()?.includes("a") || newValue?.value?.toLowerCase()?.includes("p")) ? { label: newValue?.label, value: newValue?.value?.split(" ")[0] } : newValue
            setTimeSelected(time);
        } else {
            let timeValue = "";
            let timeLabel = "";
            let timeArr = splitFromFirstAlphabet(newValue);
            timeArr[0] = timeArr?.[0]?.split(" ")?.join("");
            if (timeArr[1]?.toLowerCase() === "pm" || timeArr[1]?.toLowerCase() === "p") {
                timeValue = `${parseInt(timeArr[0].split(":")?.[0]) === 12 ? parseInt(timeArr[0].split(":")?.[0]) : parseInt(timeArr[0].split(":")?.[0]) + 12}:${timeArr[0].split(":")?.[1]}`
                timeLabel = `${timeArr[0]} PM`
            } else {
                timeValue = `${timeArr[0]}`
                timeLabel = `${timeArr[0]} AM`
            }
            setTimeSelected({ label: timeLabel, value: timeValue });
        }
    }

    const splitFromFirstAlphabet = (str) => {
        for (let i = 0; i < str?.length; i++) {
            if (/[a-zA-Z]/.test(str[i])) {
                return [str.slice(0, i), str.slice(i)];
            }
        }
        return [str, ''];
    }

    // get all issues assigned to user
    const getUserIssues = async () => {
        const payload = {
            "project_ids": "",
            "bucket_type": "user_issues",
            "requested_user_code": decryptData(sessionStorage.getItem("user_code"))
        }
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETUSERISSUES"), payload);
            if (res) {
                const issues = _.sortBy(_.uniq(res?.body?.data?.issue_list, "issue_key"), "issue_key");
                setOptions((prev) => ({ ...prev, tasks: issues }));
            }
        }
        catch (error) {
            console.error("Error", error)
        }
    }
    const formatTime = (h, m) => {
        const hour12 = (h % 12 === 0) ? 12 : h % 12;
        const ampm = h < 12 ? "AM" : "PM";
        return `${hour12}:${m.toString().padStart(2, '0')} ${ampm}`;
    };

    // func to generate options of time dropdown
    const generateTimeSlots = () => {
        const timeSlots = [];
        const durationMinutes = logData?.entered_hours || 60;
        let hours = 9;

        for (let i = 0; i < 24; i++) {
            for (let j = 0; j < 4; j++) {
                const minutes = j * 15;
                const totalStartMinutes = hours * 60 + minutes;
                const totalEndMinutes = totalStartMinutes + durationMinutes;
                const endHour = Math.floor(totalEndMinutes / 60) % 24;
                const endMinute = totalEndMinutes % 60;
                timeSlots.push({
                    label: `${formatTime(hours, minutes)}-${formatTime(endHour, endMinute)}`,
                    value: `${String(hours).padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
                });
            }
            hours = (hours + 1) % 24;
        }

        return timeSlots;
    };


    // func to get minutes from log hour string
    const getMinutes = (val) => {
        const timeArr = val?.split(" ");
        let hours = 0;
        let minutes = 0;
        let dayHours = 0;
        timeArr?.forEach((str) => {
            if (str[str?.length - 1]?.toLowerCase() === "h") {
                hours = parseFloat(str?.slice(0, str?.length - 1));
            } else if (str[str?.length - 1]?.toLowerCase() === "m") {
                minutes = parseInt(str?.slice(0, str?.length - 1));
            } else if (str[str?.length - 1]?.toLowerCase() === "d") {
                dayHours = parseFloat(str?.slice(0, str?.length - 1)) * 8;
            }
        })
        if (hours > 0) {
            minutes += hours * 60;
        }
        if (dayHours > 0) {
            minutes += dayHours * 60;
        }
        return minutes;
    }

    // when user enters log hours
    const handleTimeSpent = (val) => {
        const totMinutes = logData.remainingApi * 60;
        const enteredHours = getMinutes(val);
        let minutes = getMinutes(val);

        if (!_.isEmpty(editLogData)) {
            const timeSpent = getMinutes(editLogData?.timeSpent);
            minutes = minutes - timeSpent;
        }

        let calculatedTotal = (totMinutes - minutes) / 60;
        if (calculatedTotal < 0) {
            calculatedTotal = 0;
        }
        setLogData((prev) => ({ ...prev, entered_hours_string: val, entered_hours: enteredHours, remaining: calculatedTotal }))
        calculatePercentage((logData.logged * 60) + minutes);
    }

    // for progress bar
    const calculatePercentage = (minutes) => {
        const totEstimate = logData.estimate * 60;
        if (totEstimate > 0) {
            const percent = (minutes * 100) / totEstimate;
            setProgressValue(percent?.toFixed(2));
        } else {
            setProgressValue(0);
        }
    }

    // to auto select projects and types when task selected
    const handleTaskSelect = (val) => {
        const task = val;
        if (!_.isEmpty(task) && task?.status_name?.toLowerCase() !== "in progress") {
            getStatusOptions(task)
            setShowStatusPopup((prev) => ({ ...prev, show: true, rowdata: task }));
            return;
        }

        val !== undefined && getUserWorklogHours(task?.issue_id)
        const project = _.findWhere(options.projects, { project_id: task?.project_id });
        const type = _.findWhere(options.types, { issue_type_id: task?.issue_type_id });
        setOptionSelected((prev) => ({ ...prev, tasks: task, projects: project, types: type }));
        setSelectFromTask(true);
        if (type === undefined && val !== undefined) {
            setOptions((prevState) => ({ ...prevState, types: [{ issue_type_id: val.issue_type_id, issue_type_name: val.issue_type_name }], is_disabled: true }))
            setOptionSelected((prev) => ({ ...prev, tasks: task, projects: project, types: { issue_type_id: val.issue_type_id, issue_type_name: val.issue_type_name } }))
        } else if (val === undefined) {
            setProgressValue(0)
            setOptions((prevState) => ({ ...prevState, types: [], is_disabled: false }))
        }
    }

    // get info about estimate and all when task selected
    const getUserWorklogHours = async (issue) => {
        try {
            const response = await services.getInvokeRemote("POST", Urls("GETUSERWORKLOGHOURS"), { "issue_id": issue });
            if (response) {
                const data = response?.body?.data?.worklog_summary?.[0];
                const estimate = getMinutes(data?.planned_hours) / 60;
                const remaining = getMinutes(data?.remaining_hours) / 60;
                const logged = getMinutes(data?.log_hours) / 60;
                setLogData((prev) => ({ ...prev, estimate: estimate || 0, remaining: remaining || 0, remainingApi: remaining || 0, logged: logged || 0 }))
            }
        } catch (error) {
            console.error("error geting logs hour info", error);
        }
    }

    // get data to edit
    const getEditData = async () => {
        try {
            const payload = {
                "date": editLogData?.day_date !== undefined ? editLogData?.day_date : "",
                "project_id": editLogData?.project_id !== undefined ? parseInt(editLogData?.project_id) : 0,
                "issue_id": editLogData?.issue_id !== undefined ? parseInt(editLogData?.issue_id) : 0,
                "timesheet_worklog_id": editLogData?.timesheet_worklog_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETUSERWORKLOG"), payload);
            if (res) {
                const data = res?.body?.data?.worklog_summary?.[0];
                // setTimeSelected({})
                setApiEditData(data);
            }
        } catch (error) {
            console.error("error getting edit data", error);
        }
    }

    // set all when edit clicked
    const handleEditValues = () => {
        setError("");
        const project = _.findWhere(options.projects, { project_id: apiEditData?.project_id }) || {};
        const task = _.findWhere(options.tasks, { issue_id: apiEditData?.issue_id }) || {};
        const client = _.findWhere(options?.all_clients, { client_id: apiEditData?.client_id })
        setOptionSelected((prev) => ({ ...prev, projects: project, tasks: task, client: client, is_disabled: true }));
        handleProjectIssueType(project);
        setDateSelected(new Date(apiEditData?.log_date));
        const time = apiEditData?.log_time?.split(":").slice(0, 2).join(":");
        if (!_.isEmpty(_.findWhere(timeDropdown, { value: time }))) {
            setTimeSelected(_.findWhere(timeDropdown, { value: time }));
        } else {
            if (time?.split(":")?.[0] > 12) {
                setTimeSelected({ label: `${parseInt(time?.split(":")?.[0]) - 12}:${time?.split(":")?.[1]} PM`, value: time });
            } else {
                setTimeSelected({ label: `${parseInt(time?.split(":")?.[0])}:${time?.split(":")?.[1]} AM`, value: time });
            }
        }

        // set log related data
        getUserWorklogHours(apiEditData?.issue_id);
        const logHours = apiEditData?.log_hours?.split(" ")?.[1]?.split("m")?.[0] === '0' ? apiEditData?.log_hours?.split(" ")?.[0] : apiEditData?.log_hours
        const entered = getMinutes(apiEditData?.log_hours);
        setLogData((prev) => ({ ...prev, entered_hours_string: logHours, entered_hours: entered }))

        // disable project and issue type dropdown
        setSelectFromTask(true);

        // set description
        setLogsValue(apiEditData?.comment);
    }

    // to neglect html tags to count words
    const validateWordCount = (htmlString) => {
        const plainText = htmlString.replace(/<[^>]*>/g, '');
        const trimmedText = plainText.trim();
        const words = trimmedText.split(/\s+/);
        const wordCount = words.length;
        if (wordCount === 1) {
            if (words[0]?.length === 0) {
                return 0;
            }
        }
        return wordCount
    }

    const validateTime = (timeString) => {
        const timeRegex = /^(?:[0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        return timeRegex.test(timeString);
    };

    // to save logs
    const handleSaveLog = async () => {
        try {
            if (!_.isEmpty(optionSelected.projects) && _.isEmpty(optionSelected.tasks) && _.isEmpty(optionSelected.client)) {
                showInfo("info", "Please select client");
                return;
            } else if (!_.isEmpty(optionSelected.projects) && _.isEmpty(optionSelected.tasks) && !_.isEmpty(options?.project_module) && _.isEmpty(optionSelected.project_module)) {
                showInfo("info", "Please select project module");
                return;
            } else if (!_.isEmpty(optionSelected.projects) && _.isEmpty(optionSelected.tasks) && _.isEmpty(optionSelected.types)) {
                showInfo("info", "Please select issue type");
                return;
            } else if (_.isEmpty(optionSelected.projects) && !_.isEmpty(optionSelected.types) && _.isEmpty(optionSelected.tasks)) {
                showInfo("info", "Please select project");
                return;
            } else if (_.isEmpty(optionSelected.projects) && _.isEmpty(optionSelected.types) && _.isEmpty(optionSelected.tasks)) {
                showInfo("info", "Please select task");
                return;
            } else if (logData.entered_hours === 0) {
                showInfo("info", "Please enter the log hours");
                return;
            } else if (_.isEmpty(timeSelected) || timeSelected?.value?.length === 0) {
                showInfo("info", "Please select the log time");
                return;
            } else if (typeof (timeSelected) === "object" && !validateTime(timeSelected?.value)) {
                showInfo("info", "Please select correct log time");
                return;
            } else if (validateWordCount(logsValue) < (optionSelected?.types?.min_log_words || 5)) {
                showInfo("info", `Logs description should contain more than ${optionSelected?.types?.min_log_words || 5} words`);
                return;
            } else if (error) {
                showInfo("info", "Please enter correct log hours");
                return;
            } else {
                setOptions((prev) => ({ ...prev, isSet: false }))
                setLoaderButton(true);
                let timeString = "";
                if (timeSelected?.value?.[0] !== "0") {
                    let time = timeSelected?.value?.split(":");
                    time[0] = time?.[0]?.padStart(2, '0');
                    timeString = `${time?.join(":")}`;
                } else {
                    timeString = `${timeSelected.value}`;
                }
                const dt = DateTime.fromISO(`${dateConvert(dateSelected, "iso-string")?.split("T")?.[0]}T${timeString}`);
                let payload = {
                    "issue_id": optionSelected.tasks?.issue_id || 0,
                    "comment": logsValue,
                    "worklog_id": !_.isEmpty(editLogData) ? (apiEditData?.worklog_id !== null ? parseInt(apiEditData?.worklog_id) : 0) : 0,
                    "is_atlassian_log": _.isEmpty(optionSelected.tasks) ? false : true,
                    "timespentseconds": (logData?.entered_hours * 60),
                    "product_code": !_.isEmpty(editLogData) ? editLogData?.product_code : optionSelected?.types?.product_code || 1002,
                    "project_id": optionSelected.projects?.project_id || 0,
                    "project_module_id": optionSelected?.project_module?.option_id || 0,
                    "issue_type_id": optionSelected.types?.issue_type_id || 0,
                    "timesheet_worklog_id": !_.isEmpty(editLogData) ? parseInt(editLogData?.timesheet_worklog_id) : 0,
                    "log_datetime": dt.toFormat("yyyy-MM-dd'T'HH:mm:ss") || `${dateConvert(dateSelected, "iso-string")?.split("T")?.[0]}T${timeString}`,
                    "requested_user_code": selectedEmployee?.user_code || userCode,
                    "client_id": optionSelected?.client?.client_id
                }
                const response = await services.getInvokeRemote("POST", Urls("UPSERTMYTIMESHEETCALENDARDETAILS"), payload);
                if (response?.body.StatusCode === 400 || response?.body.StatusCode === 204 || response?.body.StatusCode === 202 || response?.body.StatusCode === 401 || response?.body.StatusCode === 500) {
                    showError('Error', response?.body.errorMessage);
                    setLoaderButton(false);
                    return;
                } else if (!response?.body?.error_status) {
                    showSuccess("success", response?.body?.message);
                    setLoaderButton(false);
                    if (!navigateDate || payload?.timesheet_worklog_id !== 0) {
                        handleReset();
                    }
                    if (onSave !== undefined) {
                        onSave();
                        if (!navigateDate || payload?.timesheet_worklog_id !== 0) {
                            handleDateSelected(dateSelected);
                        }
                    }

                    if (navigateDate && payload?.timesheet_worklog_id === 0) {
                        const date = new Date(dateSelected);
                        date.setDate(date.getDate() + 1);
                        setDateSelected(date);
                        handleDateSelected(date);
                    }
                    if (addLogData !== undefined) {
                        closePopup()
                        setEditLogData({})
                    }
                    GetMyLogTimeDetails();
                } else {
                    showError("error", response?.body?.message);
                    setLoaderButton(false);
                    return;
                }
            }
        } catch (error) {
            console.error("error saving logs", error);
            setLoaderButton(false);
            showError("error", error.response.data.errorMessage);
        }
    }

    const handleReset = () => {
        setOptionSelected({ tasks: {}, projects: {}, types: {}, client: {}, });
        setLogData({ estimate: 0, remaining: 0, remainingApi: 0, logged: 0, entered_hours: 0, entered_hours_string: "" });
        setTimeSelected({});
        setProgressValue(0);
        setApiEditData({})
        setLogsValue("");
        setEditLogData({});
    }

    const handleValidation = (val, setError) => {
        if (val) {
            const pattern = /^(\d+(\.\d+)?[dD]\s*)?(\d+(\.\d+)?[hH]\s*)?(\d+(\.\d+)?[mM]\s*)?$/i;
            if (pattern.test(val.trim())) {
                const minutes = getMinutes(val);
                if (minutes < 15) {
                    setError("Time Spent should not be less than 15m");
                    return;
                } else {
                    setError("");
                }
            } else {
                setError("Enter time spent in correct format (1d 3h 30m)");
                return;
            }
        }
    }
    //handle project issue type based on project
    const handleProjectIssueType = async (project) => {
        try {
            const response = await services.getInvokeRemote("POST", Urls("GETPROJECTISSUETYPE"), { "project_id": project ? project?.project_id : optionSelected?.projects?.project_id });
            if (response) {
                const issueType = _.sortBy(_.filter(response?.body?.data?.project_issue_types, (item) => item?.issue_type_name), "issue_type_name");
                setOptions((prev) => ({ ...prev, types: issueType }));
                if (!_.isEmpty(editLogData)) {
                    const type = _.findWhere(issueType, { issue_type_id: apiEditData?.issue_type_id });
                    setOptionSelected((prev) => ({ ...prev, types: type }));
                    if (!_.isEmpty(apiEditData)) {
                        const issue_type = _.findWhere(issueType, { issue_type_id: apiEditData?.issue_type_id }) || {};
                        if (!_.isEmpty(issue_type)) {
                            setOptionSelected((prev) => ({ ...prev, types: issue_type }));
                        } else {
                            setOptions((prevState) => ({ ...prevState, types: [{ issue_type_id: apiEditData?.issue_type_id, issue_type_name: apiEditData?.issue_type_name }], is_disabled: true }))
                            setOptionSelected((prev) => ({ ...prev, types: { issue_type_id: apiEditData?.issue_type_id, issue_type_name: apiEditData?.issue_type_name } }))
                        }
                    }
                }
            }
        } catch (error) {
            console.error("error geting logs hour info", error);
        }
    }

    const formatTimeDropdown = (logTimeSlots) => {
        const allSlots = generateTimeSlots();
        const blockedTimeValues = [];
        logTimeSlots.forEach((log) => {
            const [startStr, endStr] = log?.log_time?.split('-');
            const startTime = convertTo24HourFormat(startStr);
            const endTime = convertTo24HourFormat(endStr);

            allSlots.forEach((item) => {
                if (item.value >= startTime && item.value < endTime) {
                    blockedTimeValues.push(item.value);
                }
            });
        });
        const filteredArray = allSlots.filter(item => !blockedTimeValues.includes(item.value));
        setTimeDropdown(filteredArray);
    }

    // this function handle delete logs
    // eslint-disable-next-line
    const handleDeleteLogs = async (rowdata, callApi) => {
        if (!callApi) {
            setConfirmationPopup(true);
            return;
        } else {
            try {

                const payload = {
                    timesheet_worklog_id: parseInt(rowdata?.timesheet_worklog_id),
                    product_code: parseInt(rowdata?.product_code),
                    issue_id: parseInt(rowdata?.issue_id) || 0,
                    worklog_id: parseInt(rowdata?.worklog_id) || 0,
                    is_atlassian_log: rowdata?.issue_id ? true : false,
                    requested_user_code: selectedEmployee?.user_code || 0
                }
                const response = await services.getInvokeRemote("POST", Urls("DELETEMYTIMESHEETCALENDARDETAILS"), payload);
                if (response) {
                    showSuccess("success", response?.body?.message);
                    handleDateSelected();
                    GetMyLogTimeDetails()
                    setConfirmationPopup(false);
                }
            } catch (error) {
                setConfirmationPopup(false);
                showError("Error", error?.response?.data?.errorMessage);
                console.error("error deleting log", error);
            }
        }
    }

    const GetMyLogTimeDetails = async () => {

        try {
            const payload = {
                "from_date": new Date(dateSelected)?.toLocaleString("en-GB")?.split(",")[0]?.split("/")?.reverse()?.join("-"),
                "to_date": new Date(dateSelected)?.toLocaleString("en-GB")?.split(",")[0]?.split("/")?.reverse()?.join("-"),
                "requested_user_code": selectedEmployee?.user_code || userCode
            }
            const res = await services.getInvokeRemote("POST", Urls("GETMYTIMESHEETCALENDARLOGTIMEDETAILS"), payload);
            if (res?.body?.data?.mytimesheet_logtime_details) {
                setLogDetails(res?.body?.data?.mytimesheet_logtime_details)
            } else {
                setLogDetails([])
            }
            setOptions((prev) => ({ ...prev, isSet: true }))
        } catch (error) {
            console.error("error deleting log", error);
        }
    }

    useEffect(() => {
        dateSelected && GetMyLogTimeDetails()
    }, [dateSelected])

    const importPmoData = async (filterValue, setFilterValue) => {
        if (!filterValue?.importDate?.[0] && !filterValue?.importDate?.[1]) {
            showInfo("Info", "Please select date.");
            return;
        }
        setSpin(true)
        const res = await handleUpsertImportData({ api_key: "gt_import_employee_timesheet_save" }, filterValue, selectedEmployee, "timesheet");
        setSpin(false)
        if (res) {
            setFilterValue({ hoveredRange: filterValue?.importDate })
            setImportDataPopup("getData")
        }
    }

    useEffect(() => {
        if (importDataPopup === "getData") {
            handleDateSelected()
            setImportDataPopup(false)
        }
    }, [importDataPopup])

    useEffect(() => {
        isMyBucket && handleDateSelected()
    }, [isMyBucket])

    useEffect(() => {
        if (!isMyBucket || !clickedRowTaskId || !options.tasks?.length) return;
        const task = _.find(options.tasks, t =>
            t.issue_id === clickedRowTaskId ||
            t.issue_key === clickedRowTaskId
        );
        if (task) {
            setOptionSelected(p => ({ ...p, tasks: task }));
            handleTaskSelect(task);
        }
    }, [isMyBucket, clickedRowTaskId, options.tasks]);

    const getStatusOptions = async (rowdata) => {
        try {
            setShowStatusPopup((prev) => ({ ...prev, loader: true }));
            const payload = {
                issueId: rowdata?.issue_id
            }
            const res = await services.getInvokeRemote("POST", Urls("IMPORTTRANSITIONSFORISSUE"), payload);
            if (!res?.body?.error_status) {
                const data = res?.body?.data?.transitions;
                if (data?.length > 0 && _.pluck(data, "name").includes(rowdata?.status_name)) {
                    setShowStatusPopup((prev) => ({ ...prev, statusList: data, selectedStatus: _.findWhere(data, { name: rowdata?.status_name }), loader: false }));
                } else {
                    setShowStatusPopup((prev) => {
                        const currentState = prev;
                        const newItems = Array.isArray(data)
                            ? data
                            : [];

                        return {
                            ...currentState,
                            statusList: [...[{
                                id: "0",
                                name: rowdata?.status_name || ""
                            }], ...newItems,],
                            selectedStatus: {
                                id: "0",
                                name: rowdata?.status_name || ""
                            },
                            loader: false
                        };
                    });


                }
            }
        } catch (error) {
            console.error("Error: ", error);
            setShowStatusPopup((prev) => ({ ...prev, selectedStatus: { id: "0", name: rowdata?.status_name }, loader: false }));
        }
    }
    const handleStatusChange = async (status) => {
        try {
            setShowStatusPopup((prev) => ({ ...prev, loader: true }));
            const payload = {
                IssueId: showStatusPopup?.rowdata?.issue_id,
                DestinationStage: status?.name
            }
            const res = await services.getInvokeRemote("POST", Urls("UPDATEISSUESTAGE"), payload);
            if (res?.body.StatusCode === 400 || res?.body.StatusCode === 204 || res?.body.StatusCode === 202 || res?.body.StatusCode === 401 || res?.body.StatusCode === 500) {
                showError('Error', res?.body.errorMessage);
                setShowStatusPopup((prev) => ({ ...prev, loader: false }));
                return;
            } else if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                setShowStatusPopup((prev) => ({ ...prev, show: false, loader: false }));
                handleTaskSelect({ ...showStatusPopup?.rowdata, status_name: status?.name })
                const task = options?.tasks
                    ? options.tasks.map(obj =>
                        obj.issue_id === showStatusPopup?.rowdata?.issue_id
                            ? { ...obj, status_name: status?.name }
                            : obj
                    )
                    : [];

                setOptions((prev) => ({ ...prev, tasks: task }));
                setTimeout(() => {
                    getUserIssues()
                }, 4000);
            } else {
                showError("Error", res?.body?.message);
                setShowStatusPopup((prev) => ({ ...prev, loader: false }));
            }
        } catch (error) {
            console.error("Error: ", error)
        }
    }


    return useMemo(() => ({
        logData, dateSelected, setDateSelected, timeDropdown, timeSelected, handleTimeSpent, progressValue, options, optionSelected, setOptionSelected, handleTaskSelect, selectFromTask, handleSaveLog, handleTimeSelected, addLogData, handleReset, handleValidation, error, setError, validateWordCount, logsValue, setLogsValue, loaderButton, setOptions, navigateDate, setNavigateDate, tagRef, importDataPopup, setImportDataPopup, spin,
        selectedEmployee, userCode, confirmationPopup, handleDeleteLogs, getProjectModule, sidebarCollapsed, setSidebarCollapsed, setConfirmationPopup, setEditLogData, importPmoData, isMyBucket, clickedRowTaskId, showStatusPopup, setShowStatusPopup, handleStatusChange,
    }), [logData, dateSelected, setDateSelected, timeDropdown, timeSelected, handleTimeSpent, progressValue, options, optionSelected, setOptionSelected, handleTaskSelect, selectFromTask, handleSaveLog, handleTimeSelected, addLogData, handleReset, handleValidation, error, setError, validateWordCount, logsValue, setLogsValue, loaderButton, setOptions, navigateDate, setNavigateDate, tagRef, selectedEmployee, userCode, confirmationPopup, handleDeleteLogs, getProjectModule, sidebarCollapsed, setSidebarCollapsed, setConfirmationPopup, setEditLogData, importDataPopup, setImportDataPopup, spin, importPmoData, isMyBucket, clickedRowTaskId, showStatusPopup, setShowStatusPopup, handleStatusChange,])
}